<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params:{id: $route.params.project_id}}">Project Overview</router-link></li>
              <li class="active">
                <span>Project Report</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Project Report - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: project.id}}">{{project.name}}</router-link>
          </h3>
          <small>Project Report</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-xs-12">
          <my-documents v-if="project" :project-id="project.id" origin="project_report_pdf"></my-documents>
        </div>
      </div>

      <div class="hpanel" id="custom">
        <div class="panel-heading" @click="showHide" style="cursor: pointer">
          Customize report
          <div class="pull-right text-right">
            <button type="button" class="btn btn-info btn-outline btn-xs showhide">
              <i class="fa fa-chevron-up"></i>
            </button>
          </div>
        </div>
        <div class="panel-body" v-if="project">

          <div>
            <h3>Subproject Selection</h3>

            <div style="margin-left: 50px">

              <div class="checkbox checkbox-info" v-for="(subproject, key) in project.lists" :key="key">
                <input type="checkbox" v-model="subprojectSelected[subproject.id]" :id="subproject.id">
                <label class="" :for="subproject.id"> {{subproject.title}}</label>
              </div>
            </div>
          </div>

          <div style="margin-top: 20px">
            <h2>Content Selection</h2>

            <div style="margin-left: 50px">
              <div class="checkbox checkbox-info">
                <input type="checkbox" id="biblio-preview" v-model="biblioPreviewChecked">
                <label class="" for="biblio-preview"> Biblio preview</label>
              </div>

              <div class="checkbox checkbox-info">
                <input type="checkbox" id="question" v-model="questionChecked" :disabled="project.workflow_id === 1">
                <label class="" for="question"> Question</label>
              </div>

              <div class="checkbox checkbox-info">
                <input type="checkbox" id="contact" v-model="contactChecked" :disabled="project.workflow_id === 1">
                <label class="" for="contact"> Contact</label>

                <div class="checkbox checkbox-info">
                  <input type="checkbox" id="mailing-text" v-model="mailingTextChecked" :disabled="project.workflow_id === 1">
                  <label class="" for="mailing-text"> Mailing Text</label>

                </div>
                <div class="checkbox checkbox-info">
                  <input type="checkbox" id="mailing-stats" v-model="mailingStatsChecked" :disabled="project.workflow_id === 1">
                  <label class="" for="mailing-stats"> Mailing Statistics</label>

                </div>
                <div class="checkbox checkbox-info">
                  <input type="checkbox" id="contacted-experts" v-model="contactedExpertsChecked" :disabled="project.workflow_id === 1">
                  <label class="" for="contacted-experts"> Contacted Experts</label>

                </div>

              </div>

              <div class="checkbox checkbox-info">
                <input type="checkbox" id="biblio-content" v-model="biblioContentChecked">
                <label class="" for="biblio-content"> Biblio Content</label>
              </div>

              <div class="checkbox checkbox-info">
                <input type="checkbox" id="experts-companies" v-model="expertsCompaniesChecked">
                <label class="" for="experts-companies"> Experts & Companies</label>
              </div>

            </div>
          </div>
          <div class="row text-center" style="margin-top: 10px;">
            <vue-ladda type="submit" :loading="submitPdf.loading" class="btn btn btn-info" :data-style="submitPdf.dataStyle" @click="previewReport()">Preview Report</vue-ladda>
          </div>
        </div>
      </div>

      <template v-if="preview">

        <div class="row" id="actions" :style="cssProps" v-if="allResourcesDisplay">
          <div class="col-xs-12 col-md-6 text-center m-t">
            <vue-ladda type="submit" :loading="submitPdf.loading" class="btn btn btn-info" :data-style="submitPdf.dataStyle" @click="pdfReport()">Generate PDF Report</vue-ladda>
          </div>

          <div class="col-xs-12 col-md-6 text-center m-t" v-if="$user.isBicWorld()">
            <vue-ladda type="submit" :loading="submitKMS.loading" class="btn btn btn-warning" :data-style="submitKMS.dataStyle" @click="openModalBic()">Upload on KMS</vue-ladda>
          </div>

          <div class="col-xs-12 col-md-6 text-center m-t" v-if="$user.canBlockchain()">
            <vue-ladda type="submit" :loading="submitTimestamp.loading" class="btn btn btn-info" :data-style="submitTimestamp.dataStyle" @click="openModalTimestamp()"
                       data-toggle="popover" :data-content="helpProtect">Protect report </vue-ladda>
          </div>

        </div>

        <div class="hpanel">
          <div class="panel-heading">
            The Project
          </div>
          <div class="panel-body" v-if="project">
            <h3>{{project.name}}</h3>
            <div v-html="project.description" style="margin-top: 15px"></div>
          </div>
        </div>

        <div class="hpanel" v-if="biblioPreviewChecked">
          <div class="panel-heading">
            Biblio preview
          </div>
          <div class="panel-body">
            <div v-if="subprojectSelected[list.id] === true" v-for="(list, key) in project.lists" :key="key">
              <div style="margin-bottom: 25px">
                <list-report ref="previewBiblio" :listId="list.id" :displayBiblioPreview="biblioPreviewChecked" @resourcesLoaded="biblioLoaded"></list-report>
              </div>
            </div>
          </div>
        </div>

        <div class="hpanel" v-if="question && questionChecked">
          <div class="panel-heading">
            The Question
          </div>
          <div class="panel-body">
            <question-report :question="question" @resourcesLoaded="questionLoaded"></question-report>
          </div>
        </div>

        <div class="hpanel" v-if="question && contactChecked">
          <div class="panel-heading">
            Contact
          </div>
          <div class="panel-body">
            <ol style="margin-bottom: 15px">
              <div v-for="(mailing, key) in question.mailing" :key="key">
                <template v-if="mailing.sent">
                  <li style="font-size: 18px; font-weight: bold"> <span >Mailing </span> <span>({{mailing.sent | moment('LL')}})</span></li>
                  <mailing-report :mailingId="mailing.id" :displayMailingText="mailingTextChecked"
                                  :displayMailingStats="mailingStatsChecked"
                                  :displayContactedExperts="contactedExpertsChecked" @resourcesLoaded="mailingLoaded"></mailing-report>
                </template>
              </div>
            </ol>
          </div>
        </div>

        <div class="hpanel" v-if="project && (expertsCompaniesChecked === true || biblioContentChecked === true)">
          <div class="panel-heading">
            SubProjects
          </div>
          <div class="panel-body" v-if="project.lists">
            <div v-if="subprojectSelected[list.id] === true" v-for="(list, key) in project.lists" :key="key">
              <list-report :listId="list.id" :displayExpertsCompanies="expertsCompaniesChecked"
                           :displayBiblioContent="biblioContentChecked" :displayBiblioPreview="false" @resourcesLoaded="listLoaded"></list-report>
            </div>
          </div>
        </div>
      </template>
      <upload-file-bic ref="uploadFileBic2" @dataBicForUpload="uploadBicReport"></upload-file-bic>
      <action-modal-timestamp ref="modalTimestamp" @dataTimestamp="uploadTimestamp"/>
    </div>
  </div>
</template>
<style>
@media (min-width: 992px) {
  #actions .col-md-6 {
    width: var(--col-md-6);
  }
}
</style>
<script>

import QuestionReport from '../../components/question/Report'
import ListReport from '../../components/ListIdexlab/Report'
import VueLadda from 'vue-ladda'
import WithoutWatchers from '../../components/Mixins/WithoutWatchers'
import Mailing from '../mailing/Mailing'
import MailingReport from '../../components/mailing/Report'
import MyDocuments from '../../components/documents/MyDocuments'
import UploadFileBic from '../../components/modal/UploadFileBic'
import ActionModalTimestamp from '../../components/Timestamp/ActionModalTimestamp'

export default {
  mixins: [WithoutWatchers],
  components: {
    ActionModalTimestamp,
    UploadFileBic,
    MyDocuments,
    MailingReport,
    Mailing,
    QuestionReport,
    ListReport,
    VueLadda},
  props: [],
  name: 'ProjectReport',
  data () {
    return {
      preview: null,
      project: null,
      question: null,
      listIdSelected: null,
      submitPdf: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      submitKMS: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      submitTimestamp: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      subprojectSelected: {},
      biblioPreviewChecked: true,
      questionChecked: true,
      contactChecked: true,
      mailingTextChecked: true,
      mailingStatsChecked: true,
      contactedExpertsChecked: true,
      biblioContentChecked: true,
      expertsCompaniesChecked: true,
      helpProtect: 'Protect your files by recording them on the blockchain. You can later generate a proof of existence.<br> For more details, consult the Assistance',
      resourcesLoaded: {
        biblio: {},
        question: false,
        mailing: {},
        list: {}
      },
      allResourcesDisplay: false
    }
  },
  computed: {
    cssProps () {
      let nbColumn = 1

      if (this.$user.canBlockchain()) {
        ++nbColumn
      }

      if (this.$user.isBicWorld()) {
        ++nbColumn
      }
      return {
        '--col-md-6': 100 / nbColumn + '%'
      }
    }
  },
  watch: {
    contactChecked: function (val) {
      this.mailingTextChecked = val
      this.mailingStatsChecked = val
      this.contactedExpertsChecked = val
      this.contactChecked = val
    },
    mailingTextChecked: function (val) {
      this.$withoutWatchers(() => {
        if (val === true) {
          this.contactChecked = true
        } else if (this.mailingStatsChecked === false && this.contactedExpertsChecked === false) {
          this.contactChecked = false
        }
      })
    },
    mailingStatsChecked: function (val) {
      this.$withoutWatchers(() => {
        if (val === true) {
          this.contactChecked = true
        } else if (this.mailingTextChecked === false && this.contactedExpertsChecked === false) {
          this.contactChecked = false
        }
      })
    },
    contactedExpertsChecked: function (val) {
      this.$withoutWatchers(() => {
        if (val === true) {
          this.contactChecked = true
        } else if (this.mailingTextChecked === false && this.mailingStatsChecked === false) {
          this.contactChecked = false
        }
      })
    },
    resourcesLoaded: {
      handler (val, oldVal) {
        this.checkIfDisplay()
      },
      deep: true
    }
  },
  methods: {
    getResources: function () {
      let resources = ['question', 'question.files', 'question.trl', 'question.timeline', 'question.metrics',
        'question.maturities', 'question.mailing', 'lists']

      this.axios.get('project/' + this.$route.params.project_id + '?relations={' + resources.join(',') + '}')
        .then((response) => {
          this.project = response.data

          if (this.project.workflow_id === 1) {
            this.questionChecked = false
            this.contactChecked = false
            this.mailingStatsChecked = false
            this.mailingTextChecked = false
            this.contactedExpertsChecked = false
          }

          this.project.lists.forEach((list) => {
            if (this.listIdSelected !== null) {
              this.subprojectSelected[list.id] = list.id === this.listIdSelected
            } else {
              this.subprojectSelected[list.id] = true
            }
          })

          if (typeof response.data.question !== 'undefined' && response.data.question !== null) {
            this.question = response.data.question
            this.projectTags = this.question.keywords
            this.question.mailing = this.question.mailing.sort((mailing1, mailing2) => {
              return new Date(mailing1.sent) - new Date(mailing2.sent)
            })
          }
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    previewReport: function () {
      if (Object.keys(this.subprojectSelected).length !== 0) {
        this.preview = true
        this.showHide()
      } else {

      }
    },
    prepareData: function () {
      let data = {
        subprojectSelected: this.subprojectSelected,
        question: this.questionChecked,
        mailingText: this.mailingTextChecked,
        mailingStats: this.mailingStatsChecked,
        contactedExperts: this.contactedExpertsChecked,
        biblioContent: this.biblioContentChecked,
        expertsCompanies: this.expertsCompaniesChecked
      }

      if (this.biblioPreviewChecked === true) {
        data['biblioPreview'] = {}

        this.$refs.previewBiblio.forEach((component) => {
          if (this.subprojectSelected[component.listId] === true) {
            data['biblioPreview'][component.listId] = {
              img: component.getImage()
            }
          }
        })
      }
      return data
    },
    pdfReport: function () {
      this.submitPdf.loading = true
      let data = this.prepareData()
      this.axios.post('/project/' + this.$route.params.project_id + '/pdf', data).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Document under preparation',
          content: 'The document is being prepared, an email will be sent to you as soon as it is ready. You can check its status in the export menu.',
          placement: 'bottom-right'
        })
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'an error has occurred',
          content: 'an error occurred while generating the document, please consult our support',
          placement: 'bottom-right'
        })
        this.submitPdf.loading = false
      }).finally(() => {
        this.submitPdf.loading = false
      })
    },
    openModalBic: function () {
      this.submitKMS.loading = true
      this.$refs.uploadFileBic2.setTitle(this.project.name)
      this.$refs.uploadFileBic2.openModal()
    },
    uploadBicReport: function (uploadBicData) {
      let data = this.prepareData()

      data.bicworld = {
        title: uploadBicData.title,
        space: uploadBicData.space
      }

      if (uploadBicData.subSpace !== 'undefined') {
        data.bicworld.subSpace = uploadBicData.subSpace
      }

      this.axios.post('/project/' + this.$route.params.project_id + '/pdf', data).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Document under preparation',
          content: 'The document is being prepared, an email will be sent to you as soon as it is ready. You can check its status in My Documents.',
          placement: 'bottom-right'
        })
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'an error has occurred',
          content: 'an error occurred while generating the document, please consult our support',
          placement: 'bottom-right'
        })
        this.submitKMS.loading = false
      }).finally(() => {
        this.submitKMS.loading = false
      })
    },
    openModalTimestamp: function () {
      this.$refs.modalTimestamp.setProjectSelected(this.project)
      this.$refs.modalTimestamp.setIsManuallyAdded(false)
      this.$refs.modalTimestamp.setSubmitAction('event')
      this.$refs.modalTimestamp.openModal()
    },
    uploadTimestamp: function (dataTimestamp) {
      this.submitTimestamp.loading = true
      let data = this.prepareData()

      data.timestamp = {
        title: dataTimestamp.title,
        description: dataTimestamp.description,
        owners: dataTimestamp.owners
      }

      this.axios.post('/project/' + this.$route.params.project_id + '/pdf', data).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Document and Protection preparation',
          content: 'The document is being prepared and will then be protected. You will receive notification emails when completed and you can check the progress in My Documents',
          placement: 'bottom-right'
        })
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'an error has occurred',
          content: 'an error occurred while generating the document, please consult our support',
          placement: 'bottom-right'
        })
        this.submitTimestamp.loading = false
      }).finally(() => {
        this.submitTimestamp.loading = false
      })
    },
    showHide: function (event = null) {
      if (event !== null) {
        event.preventDefault()
      }

      let hpanel = $('#custom')
      let iconUp = hpanel.find('.fa-chevron-up')
      let iconDown = hpanel.find('.fa-chevron-down')
      let body = hpanel.find('div.panel-body:first')

      if (typeof iconUp !== 'undefined' && iconUp.length !== 0) {
        iconUp.toggleClass('fa-chevron-down').toggleClass('fa-chevron-up')
        this.boxOpen = false
      } else if (typeof iconDown !== 'undefined' && iconDown.length !== 0) {
        iconDown.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        this.boxOpen = true
      }

      body.slideToggle(300)
      hpanel.toggleClass('').toggleClass('panel-collapse')
    },
    biblioLoaded: function (listId) {
      this.$set(this.resourcesLoaded.biblio, listId, true)
    },
    questionLoaded: function () {
      this.resourcesLoaded.question = true
    },
    mailingLoaded: function (mailingId) {
      this.$set(this.resourcesLoaded.mailing, mailingId, true)
    },
    listLoaded: function (listId) {
      this.$set(this.resourcesLoaded.list, listId, true)
    },
    checkIfDisplay: function () {
      let display = true

      if (this.biblioPreviewChecked === true) {
        for (let listId in this.subprojectSelected) {
          if (this.subprojectSelected[listId] === true && typeof this.resourcesLoaded.biblio[listId] === 'undefined') {
            console.log('display', 1, listId)
            display = false
          }
        }
      }

      if (this.contactedExpertsChecked === true || this.biblioContentChecked === true) {
        for (let listId in this.subprojectSelected) {
          if (this.subprojectSelected[listId] === true && typeof this.resourcesLoaded.list[listId] === 'undefined') {
            console.log('display', 2, listId)
            display = false
          }
        }
      }

      if (this.question !== null) {
        if (this.questionChecked === true && this.resourcesLoaded.question !== true) {
          console.log('display', 3)
          display = false
        }

        if (this.mailingStatsChecked === true || this.mailingTextChecked === true || this.contactedExpertsChecked === true) {
          for (let key in this.question.mailing) {
            let mailing = this.question.mailing[key]
            if (mailing.sent) {
              if (this.subprojectSelected[mailing.id] === true && typeof this.resourcesLoaded.mailing[mailing.id] === 'undefined') {
                console.log('display', 4, mailing.id)
                display = false
              }
            }
          }
        }
      }

      this.allResourcesDisplay = display
    }
  },
  beforeMount () {
    this.listIdSelected = parseInt(localStorage.getItem('listIdSelected')) || null

    this.getResources()
  },
  updated () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      html: true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/project/ProjectReport.vue